import { useQuery } from 'react-query';

import { metaDataQueryKeys, orbitQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { ChatHistory } from '../../types/Orbit/Chat';

export default function useOrbitChatHistory() {
  const { get } = useApiHelper();

  const chats = useQuery({
    queryKey: orbitQueryKeys.chats(),
    queryFn: () =>
      get<IDefaultResponseWithData<ChatHistory>>('/v1/chat').then(
        (res) => res.data.data
      ),
  });

  return {
    chats,
  };
}
